<form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col items-center gap-5">
	<div class="w-full z-50">
		<angular-phone-number-input [preferredCountries]="preferredCountries" [defaultCountry]="'SN'" [border]="true"
			formControlName="phoneNumber" (phoneNumberChange)="onPhoneNumberChange($event)"
			class="w-[400px] h-[55px] rounded placeholder:text-gray-500 text-gray-700 bg-white"
			[ariaPlaceholder]="'Numéro de téléphone'" placeholder="Numéro de téléphone">
		</angular-phone-number-input>
		<div *ngIf="phoneNumberError" class="text-red-500 text-xs mt-1 ml-2">
			{{ phoneNumberError }}
		</div>
	</div>

	<div class="w-full">
		<div
			class="form-group auth-form-group-custom w-full rounded text-gray-700 overflow-hidden border border-solid border-gray-300 relative">
			<lucide-icon [img]="LockIcon" class="auti-custom-input-icon text-primary" [size]="24"></lucide-icon>
			<label class="text-sm" for="password">Mot de passe</label>
			<input [type]="showPassword ? 'text' : 'password'" formControlName="password"
				class="form-control w-full placeholder:text-sm placeholder:text-gray-400" id="password"
				placeholder="Mot de passe" />

			<button type="button" (click)="togglePasswordVisibility()"
				class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
				<lucide-icon [img]="showPassword ? EyeOffIcon : EyeIcon" [size]="24"></lucide-icon>
			</button>
		</div>
		<div *ngIf="passwordError" class="text-red-500 text-xs mt-1 ml-2">
			{{ passwordError }}
		</div>
	</div>

	<button type="submit" [disabled]="isLoading$ | async"
		class="bg-primary text-white px-4 rounded-lg py-2 text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
		<span *ngIf="!(isLoading$ | async)">Se connecter</span>
		<span *ngIf="isLoading$ | async" class="flex items-center justify-center">
			<svg class="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
				viewBox="0 0 24 24">
				<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
				<path class="opacity-75" fill="currentColor"
					d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
				</path>
			</svg>
			Connexion en cours...
		</span>
	</button>

	<button type="button" class="text-sm text-gray-500 mb-3" (click)="onForgotPassword()">Mot de passe oublié ?</button>
</form>